import { CloudDownload } from '@mui/icons-material';
import { Button, IconButton } from '@mui/material';
import { observable, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import { Minuta, Processo } from '../../modelo';
import { DadosProcesso } from '../../modelo/dominio/DadosProcesso';
import { DadosProcessoDto } from '../../modelo/dto/DadosProcessoDto';
import MinutaService from '../../services/MinutaService';
import MensagemStore from '../../store/MensagemStore';

import minutaTemplate from '@/components/editor/minutaTemplate/minuta.html?raw';

interface IPropsDownloadMinuta {
   minutaSelecionada: Minuta;
   processo?: Partial<Processo>;
   dadosProcesso?: DadosProcessoDto | DadosProcesso;
   raisedButton?: boolean;
   idProcesso?: number;
}


class DownloadMinuta extends React.Component<IPropsDownloadMinuta> {
   minutaSelecionada = this.props.minutaSelecionada;
   processo = this.props.processo;

   constructor(props: IPropsDownloadMinuta) {
      super(props);

      makeObservable(this, {
         minutaSelecionada: observable,
         processo: observable,
});
   }

   get tipoDocumentoMinutaDocx() {
      return !this.props.minutaSelecionada || (this.props.minutaSelecionada && this.props.minutaSelecionada.tipoDocumentoMinuta === 'docx') ? true : false;
   }

   downloadEditorExterno = async () => {
      let minuta = this.props.minutaSelecionada;
      const dadosProcesso = this.props.dadosProcesso;
      const descTipo = this.props.minutaSelecionada.tipo.descricao;
      const tempLink = document.createElement('a');
      let extensao = '.docx';
      let minutaData;

      if (this.tipoDocumentoMinutaDocx) {
         if (!minuta.conteudo) {
            if (minuta.minutaExterna) {
               minuta = await MinutaService.recuperarMinutaExterna(dadosProcesso.identificadorProcesso, minuta.numero, true);
            } else {
               minuta = await MinutaService.recuperarMinuta(dadosProcesso.identificadorProcesso, minuta.tipo.codigo, true, minuta.numero);
            }
         }

         if (minuta.conteudo) {
            minutaData = new Blob([Buffer.from(minuta.conteudo, 'base64')], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
         } else {
            MensagemStore.apresentarAviso("Conteúdo da minuta corrompido ou não disponível");
         }

      } else {
         const div = document.createElement('div');
         div.innerHTML = minuta.conteudo;
         const divNumeroProcesso = document.createElement('div');
         divNumeroProcesso.innerHTML = "PROCESSO Nº " + dadosProcesso.classeJudicial.sigla + '-' + dadosProcesso.numero + "<br /><br />";
         divNumeroProcesso.style.fontWeight = "bold";
         divNumeroProcesso.style.fontFamily = "Courier New";
         div.children[0].insertBefore(divNumeroProcesso, div.children[0].children[0]);
         const minutaHtml = minutaTemplate + div.innerHTML + "</body></html>";
         // colocar info das classes css para o editor externo
         minutaData = new Blob([minutaHtml], { type: 'text/html' });
         extensao = '.html';
      }

      const csvURL = window.URL.createObjectURL(minutaData);
      tempLink.href = csvURL;
      tempLink.setAttribute('download', descTipo + (dadosProcesso.classeJudicial ? '-' + dadosProcesso.classeJudicial.sigla : '') + '-' + dadosProcesso.numero + extensao);
      tempLink.click();
      window.URL.revokeObjectURL(csvURL);
   }

   render() {
      if (this.props.raisedButton) {
         return (
            <Button
               color='primary'
               style={{ display: 'flex', flexDirection: 'column', placeContent: 'center', alignItems: 'center' }}
               id="botaoDownloadMinuta" title="Download da Minuta" onClick={this.downloadEditorExterno}
            >
               <CloudDownload style={{ margin: '8px' }} />
            </Button >
         );
      } else {
         return (
            <IconButton id="botaoDownloadMinuta" title="Download da Minuta" onClick={this.downloadEditorExterno}
               style={{ width: '40px', height: '30px', padding: '0px' }}
            >
               <CloudDownload />
            </IconButton >
         );
      }
   }
}

export default observer(DownloadMinuta);
